export type GamePrize = {
  selections: number;
  items: GamePrizeItem[];
} 

export type GamePrizeItem = {
  matches: number[];
  lose: boolean;
  winMultiplier: number;
}

let PRIZES = new Map<number, GamePrize>();

//Prize #1
PRIZES.set(1, {
  selections: 1,
  items: [
    {
      matches: [0],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [1],
      lose: false,
      winMultiplier: 3,
    }
  ]
});

//Prize #2
PRIZES.set(2, {
  selections: 2,
  items: [
    {
      matches: [0,1],
      lose: true,
      winMultiplier: 0
    },
    {
      matches: [2],
      lose: false,
      winMultiplier: 12
    },
  ]
});

//Prize #3
PRIZES.set(3, {
  selections: 3,
  items: [
    {
      matches: [0,1],
      lose:  true,
      winMultiplier: 0,
    },
    {
      matches: [2],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [3],
      lose:  false,
      winMultiplier: 44,
    }
  ]
});

//Prize #4
PRIZES.set(4, {
  selections: 4,
  items: [
    {
      matches: [0,1],
      lose: true,
      winMultiplier: 0
    },
    {
      matches: [2],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [3],
      lose:  false,
      winMultiplier: 4,
    },
    {
      matches: [4],
      lose:  false,
      winMultiplier: 120,
    }
  ]
});

//Prize #5
PRIZES.set(5, {
  selections: 5,
  items: [
    {
      matches: [0,1,2],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [3],
      lose:  false,
      winMultiplier: 2,
    },
    {
      matches: [4],
      lose:  false,
      winMultiplier: 14,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 640,
    }
  ]
});

//Prize #6
PRIZES.set(6, {
  selections: 6,
  items: [
    {
      matches: [0,1,2],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [3],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [4],
      lose:  false,
      winMultiplier: 5,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 8,
    },
    {
      matches: [6],
      lose:  false,
      winMultiplier: 1800,
    }
  ]
});

//Prize #7
PRIZES.set(7, {
  selections: 7,
  items: [
    {
      matches: [0,1,2],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [3],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [4],
      lose:  false,
      winMultiplier: 3,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 12,
    },
    {
      matches: [6],
      lose:  false,
      winMultiplier: 125,
    },
    {
      matches: [7],
      lose:  false,
      winMultiplier: 5000,
    }
  ]
});

//Prize #8
PRIZES.set(8, {
  selections: 8,
  items: [
    {
      matches: [0,1,2,3],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [4],
      lose:  false,
      winMultiplier: 2,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 7,
    },
    {
      matches: [6],
      lose:  false,
      winMultiplier: 60,
    },
    {
      matches: [7],
      lose:  false,
      winMultiplier: 675,
    },
    {
      matches: [8],
      lose:  false,
      winMultiplier: 25000,
    }
  ]
});

//Prize #9
PRIZES.set(9, {
  selections: 9,
  items: [
    {
      matches: [0,1,2,3],
      lose: true,
      winMultiplier: 0,
    }, 
    {
      matches: [4],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 5,
    },
    {
      matches: [6],
      lose:  false,
      winMultiplier: 20,
    },
    {
      matches: [7],
      lose:  false,
      winMultiplier: 210,
    },
    {
      matches: [8],
      lose:  false,
      winMultiplier: 2500,
    },
    {
      matches: [9],
      lose:  false,
      winMultiplier: 100000,
    },
  ]
});

//Prize #10
PRIZES.set(10, {
  selections: 10,
  items: [
    {
      matches: [0,1,2,3],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [4],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 2,
    },
    {
      matches: [6],
      lose:  false,
      winMultiplier: 6,
    },
    {
      matches: [7],
      lose:  false,
      winMultiplier: 50,
    },
    {
      matches: [8],
      lose:  false,
      winMultiplier: 580,
    },
    {
      matches: [9],
      lose:  false,
      winMultiplier: 10000,
    },
    {
      matches: [10],
      lose:  false,
      winMultiplier: 1000000,
    },
  ]
});

//Prize #15
PRIZES.set(15, {
  selections: 15,
  items: [
    {
      matches: [0,1,2,3,4],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [5],
      lose:  false,
      winMultiplier: 1,
    },
    {
      matches: [6],
      lose:  false,
      winMultiplier: 2,
    },
    {
      matches: [7],
      lose:  false,
      winMultiplier: 4,
    },
    {
      matches: [8],
      lose:  false,
      winMultiplier: 20,
    },
    {
      matches: [9],
      lose:  false,
      winMultiplier: 50,
    },
    {
      matches: [10],
      lose:  false,
      winMultiplier: 250,
    },
    {
      matches: [11],
      lose:  false,
      winMultiplier: 2000,
    },
    {
      matches: [12],
      lose:  false,
      winMultiplier: 12000,
    },
    {
      matches: [13],
      lose:  false,
      winMultiplier: 50000,
    },
    {
      matches: [14],
      lose:  false,
      winMultiplier: 100000,
    },
    {
      matches: [15],
      lose:  false,
      winMultiplier: 250000,
    },
  ]
}); 

//Prize #20
PRIZES.set(20, {
  selections: 20,
  items: [
    {
      matches: [0],
      lose: false,
      winMultiplier: 100,
    },
    {
      matches: [1],
      lose: false,
      winMultiplier: 10,
    },
    {
      matches: [2],
      lose: false,
      winMultiplier: 2,
    },
    {
      matches: [3,4,5,6,7], //ash question
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [8],
      lose: false,
      winMultiplier: 2,
    },
    {
      matches: [9],
      lose: false,
      winMultiplier: 7,
    },
    {
      matches: [10],
      lose: false,
      winMultiplier: 20,
    },
    {
      matches: [11],
      lose: false,
      winMultiplier: 100,
    },
    {
      matches: [12],
      lose: false,
      winMultiplier: 450,
    },
    {
      matches: [13],
      lose: false,
      winMultiplier: 1200,
    },
    {
      matches: [14],
      lose: false,
      winMultiplier: 5000,
    },
    {
      matches: [15],
      lose: false,
      winMultiplier: 10000,
    },
    {
      matches: [16],
      lose: false,
      winMultiplier: 15000,
    },
    {
      matches: [17],
      lose: false,
      winMultiplier: 25000,
    },
    {
      matches: [18],
      lose: false,
      winMultiplier: 50000,
    },
    {
      matches: [19],
      lose: false,
      winMultiplier: 100000,
    },
    {
      matches: [20],
      lose: false,
      winMultiplier: 250000,
    },
  ]
});

//Prize #40
PRIZES.set(40, {
  selections: 40,
  items: [
    {
      matches: [0],
      lose: false,
      winMultiplier: 250000,
    },
    {
      matches: [1],
      lose: false,
      winMultiplier: 25000,
    },
    {
      matches: [2],
      lose: false,
      winMultiplier: 2200,
    },
    {
      matches: [3],
      lose: false,
      winMultiplier: 200,
    },
    {
      matches: [4],
      lose: false,
      winMultiplier: 35,
    },
    {
      matches: [5],
      lose: false,
      winMultiplier: 7,
    },
    {
      matches: [6],
      lose: false,
      winMultiplier: 2,
    },
    {
      matches: [7],
      lose: false,
      winMultiplier: 1,
    },
    {
      matches: [8,9,10,11,12],
      lose: true,
      winMultiplier: 0,
    },
    {
      matches: [13],
      lose: false,
      winMultiplier: 1,
    },
    {
      matches: [14],
      lose: false,
      winMultiplier: 2
    },
    {
      matches: [15],
      lose: false,
      winMultiplier: 7
    },
    {
      matches: [16],
      lose: false,
      winMultiplier: 35
    },
    {
      matches: [17],
      lose: false,
      winMultiplier: 200
    },
    {
      matches: [18],
      lose: false,
      winMultiplier: 2200
    },
    {
      matches: [19],
      lose: false,
      winMultiplier: 25000
    },
    {
      matches: [20],
      lose: false,
      winMultiplier: 250000
    },
  ]
});

export default PRIZES;
